module.exports = __webpack_public_path__ + "img/_beton.0455875b.jpg";